import { Tag } from './Tag';

export type { TypeTagsProps } from './types';
export default Tag;
